// extracted by mini-css-extract-plugin
export default {"employeeAvatarHeader":"EmployeeAvatarHeader_employeeAvatarHeader__jdttQ","headerText":"EmployeeAvatarHeader_headerText__U8hoQ","avatar":"EmployeeAvatarHeader_avatar__vv235"};